import { I18n } from 'react-redux-i18n';
import { take, put, call, all, select } from 'redux-saga/effects';
import { notify } from '../../../../../Components/Notifier/services/saga';
import { requestHandler } from '../../../../../service/fetcher.saga';

import {
	checkIfPartnerCustomerExist,
	generateExternalId,
	initApiData,
	initApiVariable,
	preGenerateLinkPartnerToCustomer,
	setActiveAuthLink,
	setApiMask,
	setPartnerMedDefaut,
	synchroBookingPartner,
} from '../saga';
import { PRE_CHANGE_PARTNER_STEP } from '../types';
import { handlePatchVariable } from '../../../../VariableServer/service/saga';

const PARTNER_PREFIX = 'kouver';

function* config() {
	while (true) {
		const { data } = yield take('PUT_CONFIG_KOUVER');
		let success = false;
		let errorMessage = null;
		let currentStep = data.step;

		let bodySetStep = {
			id_user: data.userId,
			partner_id: data.partnerId,
			step: data.nextStep,
			status: data.status,
		};

		const { partners } = yield select();
		let external_id =
			partners && partners[PARTNER_PREFIX]
				? partners[PARTNER_PREFIX].external_id
				: null;

		if (currentStep === 'initial') {
			yield call(setPartnerMedDefaut, {
				partnerPrefix: PARTNER_PREFIX,
				partnerId: data.partnerId,
			});

			bodySetStep.step = 'set_api_data';
			currentStep = 'set_api_data';
			success = true;
		}

		if (currentStep === 'set_api_data') {
			const successInitApiData = yield call(initApiData, PARTNER_PREFIX);
			if (successInitApiData) {
				bodySetStep.step = 'set_customer_id';
				success = true;
			}
		}

		if (currentStep === 'set_customer_id') {
			yield call(handlePatchVariable, {
				key: 'kouverCustomerId',
				value: data.customer_id,
			});
			yield put({
				type: 'PRE_REQUEST_POST_PARTNER_CHECKING',
				body: {
					partnerPrefix: PARTNER_PREFIX,
					id: data.userId,
				},
			});

			const { result } = yield take('REQUEST_POST_PARTNER_CHECKING_FINISHED');
			if (result && result.status && result.status === 'success') {
				external_id = data.customer_id;
				let resCheck = yield call(checkIfPartnerCustomerExist, {
					partner_id: data.partnerId,
					partner_customer_id: external_id,
				});

				if (!resCheck) {
					errorMessage = 'partner.link_partner_check_error';
				} else if (resCheck && resCheck.exist === false) {
					yield call(
						notify,
						I18n.t('partner.kouver_credientials_verified'),
						'success'
					);
					yield put({
						type: 'PRE_PATCH_PARTNER_EXTERNAL_ID',
						body: { prefix: PARTNER_PREFIX, external_id },
					});

					success = true;
					currentStep = 'set_auth_link';
					bodySetStep.step = 'set_auth_link';

					yield put({
						type: 'PRE_PATCH_PARTNER_EXTERNAL_ID',
						body: { prefix: PARTNER_PREFIX, external_id },
					});
				} else {
					errorMessage = 'partner.link_partner_customer_allready_exist';
				}
			} else {
				yield call(
					notify,
					I18n.t('partner.onboarding_kouver_errors.partner_checking'),
					'error',
					10000
				);
			}
		}

		if (currentStep === 'set_auth_link') {
			const res = yield call(preGenerateLinkPartnerToCustomer, {
				partnerId: data.partnerId,
				uuid: external_id,
			});

			if (res && res.success) {
				yield call(setActiveAuthLink, false, external_id, data.partnerId);
				currentStep = 'set_api_mask';
				bodySetStep.step = 'set_api_mask';
				success = true;
			} else {
				errorMessage = 'partner.onboarding_common_errors.set_auth_link';
			}

			// en plus cadeau
			yield call(initApiVariable, 'variable', 'api_reservation', '1');
		}

		if (currentStep === 'set_api_mask') {
			bodySetStep.status = 'actif';
			const setApiMaskSuccess = yield call(setApiMask, {
				...bodySetStep,
				prefix: PARTNER_PREFIX,
			});

			if (setApiMaskSuccess) {
				currentStep = 'trigger_synchro_booking';
				bodySetStep.step = 'trigger_synchro_booking';
				success = true;
			} else {
				bodySetStep.status = 'configuration';
			}
		}

		if (currentStep === 'trigger_synchro_booking') {
			yield call(synchroBookingPartner, PARTNER_PREFIX);

			bodySetStep.step = 'success';
			bodySetStep.status = 'actif';
			success = true;
		}

		if (success) {
			yield put({
				type: PRE_CHANGE_PARTNER_STEP,
				body: bodySetStep,
			});
		}

		if (errorMessage) {
			yield call(notify, I18n.t(errorMessage), 'error', 5000);
		}

		yield put({
			type: 'PUT_CONFIG_KOUVER_FINISHED',
			step: bodySetStep.step,
			external_id,
		});
	}
}

export default function* indexSaga() {
	yield all([config()]);
}
